export default __webpack_public_path__ + "static/media/34.6d44b422.png";